import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "12", r: "10", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "12", x2: "12", y1: "8", y2: "12", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "12", x2: "12.01", y1: "16", y2: "16", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "AlertCircle";
const AlertCircle = memo(themed(Icon));
export {
  AlertCircle
};
//# sourceMappingURL=alert-circle.js.map
